import { styled } from 'styled-components';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  margin-top: 4pt;
  border: 2pt solid gray;
  padding: 6pt;

  width: fit-content;
  min-width: 20rem;
  max-width: 90vw;
  overflow-y: auto;
  max-height: 30vh;

  color: #0000ff;
  background-color: #c0c0c0;
  text-align: left;
  line-height: 1.1;
  
  @media only screen and (max-width: 768px) {
    max-width: 90vw;
    padding: 12pt;
    font-size: 3rem;
    max-height: 70vh;
    box-sizing: border-box;
  }
`;

const Title = styled.h1`
  font-size: 0.53em;
  font-weight: bold;
  margin-bottom: 6pt;
  text-align: center;
  color: #0000ff;
`;

const Section = styled.div`
  margin-bottom: 4pt;
`;

const SectionTitle = styled.h2`
  font-size: 0.45em;
  font-weight: bold;
  margin-bottom: 2pt;
  color: #0000ff;
`;

const SectionContent = styled.p`
  font-size: 0.38em;
  margin: 0;
  color: #0000ff;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2pt;
  margin-bottom: 8pt;
  flex-shrink: 0;
`;

const Link = styled.a`
  font-size: 18pt !important;
  color: #0000ff;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
  padding: 0 !important;
  border: none !important;
  margin-bottom: 4pt;
  word-wrap: break-word;
  
  @media only screen and (max-width: 768px) {
    font-size: 14pt !important;
  }
  
  &:hover {
    color: #ff0000;
  }
`;

export default function TermsLayout() {
  return (
    <Container>
      <LinksContainer>
        <Link
          href='https://sanko.xyz/terms'
          target='_blank'
          rel='noopener noreferrer'
        >
          Sanko Terms of Service
        </Link>
        <Link
          href='https://sanko.xyz/privacy-policy'
          target='_blank'
          rel='noopener noreferrer'
        >
          Sanko Privacy Policy
        </Link>
      </LinksContainer>

      <Title>GOLD Usage Terms</Title>

      <Section>
        <SectionTitle>In-game only:</SectionTitle>
        <SectionContent>
          GOLD is purely an in-game currency with no real-world monetary value
          and may only be used within Sanko games for digital items and rewards
          as permitted by rules outlined by Sanko. <br />
          <br />
          Gold cannot be exchanged for real money, goods, or services. All Gold
          transactions are final and non-refundable.
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>Participation:</SectionTitle>
        <SectionContent>
          Certain activities may require you to approve or transfer GOLD to
          participate; approved GOLD may be deducted from your balance and is
          non-refundable unless stated otherwise.
        </SectionContent>
      </Section>
    </Container>
  );
}
